<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="queryLateralFilters.length !== 0" class="search-filters-list">
    <div
      v-for="el in queryLateralFilters"
      :key="el.value"
      class="pill pill--small selected"
    >
      <div class="pill-text">{{ getFilterLabel(el) }}</div>
      <div class="pill-icon-close" @click="lateralFilterChange(el.value, el.type)" />
    </div>
  </div>
</template>

<script>
import { resolveThesaurusLabel } from '@/utils/thesaurusUtils'
/**
 * List of selected Lateral Filters
 * @example [none]
 */
export default {
  name: 'SearchSelectedFilters',
  props: {
    thesaurusFilters: {
      type: Object,
    },
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    queryLateralFilters() {
      let filterObj = []
      let arrayWords = []
      if (this.$route.query.theme) {
        arrayWords = this.$route.query.theme.split(',')
        arrayWords.forEach(el =>
          filterObj.push({
            value: el,
            type: 'theme',
          })
        )
      }
      if (this.$route.query.subtheme) {
        arrayWords = this.$route.query.subtheme.split(',')
        arrayWords.forEach(el =>
          filterObj.push({
            value: el,
            type: 'subtheme',
          })
        )
      }
      if (this.$route.query.detail) {
        arrayWords = this.$route.query.detail.split(',')
        arrayWords.forEach(el =>
          filterObj.push({
            value: el,
            type: 'detail',
          })
        )
      }
      if (this.$route.query.territory) {
        arrayWords = this.$route.query.territory.split(',')
        arrayWords.forEach(el =>
          filterObj.push({
            value: el,
            type: 'territory',
          })
        )
      }
      return filterObj
    },
  },
  methods: {
    getFilterLabel(el) {
      if (el.type === 'source') return this.$t(el.value)
      if (el.type === 'territory') return this.$t(el.value.replaceAll(' ', '_'))
      let resolvedLabel = resolveThesaurusLabel(this.thesaurusFilters && this.thesaurusFilters.theme, el.value)
      if (resolvedLabel !== el.value) return resolvedLabel.replace('~', ',')
      let fallbackLabels = this.$route.query[el.type + 'Label']
      if (fallbackLabels) {
        let values = this.$route.query[el.type].split(',')
        let labels = fallbackLabels.split(',')
        let labelIndex = values.indexOf(el.value)
        if (labelIndex !== -1 && labels[labelIndex]) {
          return labels[labelIndex].replace('~', ',')
        }
      }
      return el.value.replace('~', ',')
    },
    /** Triggers an event to SearchList with information of click
     * @param {String} filtVal selected lateralfilter label
     * @param {String} filtType type of clicked filter
     * @public This is a public method
     */
    lateralFilterChange(filtVal, filtType) {
      /** Triggers event with empty string to close open lateral filter if case
       * @event toggle-filter
       */
      this.$emit('toggle-filter', '')
      /** Triggers an event to SearchList with information
       * @event lateral-filter-pressed
       * @property {String} filtVal selected lateralfilter label
       * @property {String} filtType the type of lateral filter pressed (theme, subtheme, detail, district, source)
       */
      this.$emit('lateral-filter-pressed', filtVal, filtType)
    },
  },
}
</script>

<style lang="stylus" scoped>
.search-filters-list
  display: flex
  flex-wrap: wrap
  gap: vw(10px)

.search-filters-item
  display: flex
  align-items: center
  padding: vw(6px) vw(16px)
  padding-right: vw(8px)
  border: 1px solid $corporate_color
  border-radius: 20px
  background-color: $corpotative-color-very-light
  gap: vw(6px)

.search-filters-item-text
  m-font-size(14, 20)
  margin-top: 0.1em
  color: $corporate_color

.search-filters-item-icon
  m-icon("close", 24, $corporate_color)
  cursor: pointer
</style>
